<template>
    <div class="banbar maxWidthPx" :class="{ active: isActive }" :key="isActive">
        <div class="lf">
            <img src="@/assets/images/logo.png" alt="">
        </div>
        <div class="rg">
            <div class="btn" @click="router.push('/BullMarketBrokers')">Abrir Cuenta</div>
        </div>
    </div>
    <div class="zhanwei"></div>
</template>


<script lang="ts" setup name="navbarPage">
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()

const isActive = ref(false)

// 滚动处理函数
const handleScroll = () => {
    const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

    isActive.value = scrollTop > 50 // 滚动 10px 就触发
}

onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped lang="scss">
.zhanwei {
    height: 64px;
}

.banbar {
    width: 100%;
    height: 64px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99;

    .lf {
        display: flex;
        align-items: center;

        img {
            height: 30px;
        }
    }

    .rg {
        display: flex;
        align-items: center;

        .btn {
            padding: 10px 15px;
            color: #fff;
            font-size: 12px;
            background: #1e27f3;
            border-radius: 500px;
            font-weight: 700;
        }
    }

    &.active {
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px 0px;
        background-color: #fff !important;
    }
}
</style>